import React, { FC } from 'react'
import './index.scss'

export const PageLoading: FC = () => {
  return (
    <div className="pageloading">
      <div className="pageloading-spinner"></div>
    </div>
  )
}
